export class HoCreateMessages {
  static readonly ADD_NEW_HO_COFIRM_INI = '¿Crear';
  static readonly ADD_NEW_HO_COFIRM_END = '?';
  static readonly ADD_NEW_HO_SUCCESS_INI = 'El Handover';
  static readonly ADD_NEW_HO_SUCCESS_END = 'fue creado con éxito.';
  static readonly ADD_NEW_HO_ERROR_INI =
    'Hubo un problema y el Handover no pudo ser creado.';
  static readonly ADD_NEW_HO_ERROR_END = 'Por favor, intentelo nuevamente.';
  static readonly SUCCESS_NOTIFICATION = true;
  static readonly ERROR_NOTIFICATION = false;
}
